namespace Worthington.BlogListLibrary {

    let typeOption = document.getElementById('resource-type-select') as HTMLSelectElement;
    let dataOption = document.getElementById('custom-data-select') as HTMLSelectElement;
    let loading = document.querySelector('.js-loading');

    const submitSearchTerms = (blogType:string, customAttribute:string) => {

        let newURL = window.location.href.split('?')[0];

        if (blogType && customAttribute){
            newURL = newURL + '?Criteria.BlogType=' + blogType
                            + '&Criteria.CustomAttributeFilter=' + customAttribute;
        } else if (blogType) {
            newURL = newURL + '?Criteria.BlogType=' + blogType;
        } else {
            newURL = newURL + '?Criteria.CustomAttributeFilter=' + customAttribute;
        }

        location.assign(newURL);
    };

    // HIDING for a bit
    // filtering on dd change instead of using submit
    // const validateSubmit = () => {

    //     let searchSubmit = document.querySelector('.js-search-submit');

	// 	searchSubmit.addEventListener('click', () => {

    //         // validate they have filtering values before searching
    //         if  ( (typeOption.value) || (dataOption.value) ) {
    //             // call function to construct URL string
    //             submitSearchTerms(typeOption.value, dataOption.value);
    //         } else {
    //             // noting to submit - show error
    //             let errorField = document.querySelector('.js-search-error');
    //             errorField.classList.remove('d-none');
    //         }
    //     });
    // };

    const checkURLParams = () => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const blogType = urlParams.get('Criteria.BlogType');
        const customData = urlParams.get('Criteria.CustomAttributeFilter');

        if (blogType){
            selectElement('resource-type-select', blogType);
        }
        if (customData){
            selectElement('custom-data-select', customData);
        }
        setDisabledDropDown(blogType);
    };

    const selectElement = ( id:string, valueToSelect:string ) => {
        let selectList = document.getElementById(id) as HTMLSelectElement;

        selectList.value = valueToSelect;

        // if no value matches, set selected to 0
        if (selectList.value == "" ){
            selectList.options[0].selected = true;
        }
    }

    const handleDropDownChange = () => {
        if (typeOption){
            typeOption.addEventListener('change', () => {
                //show loading indicator since we need to refresh page
                loading.classList.remove('d-none');
                // call function to construct URL string
                submitSearchTerms(typeOption.value, dataOption.value);
                setDisabledDropDown(typeOption.value);
            });
        }

        if (dataOption){
            dataOption.addEventListener('change', () => {
                //show loading indicator since we need to refresh page
                loading.classList.remove('d-none');
                // call function to construct URL string
                submitSearchTerms(typeOption.value, dataOption.value);
            });
        }
    }

    const handleClearFilter = () => {
        let clear = document.querySelector('.js-clear-filter');

        if (clear){
            clear.addEventListener('click', (e) => {
                e.preventDefault();

                //show loading indicator since we need to refresh page
                loading.classList.remove('d-none');
                // call function to construct URL string
                submitSearchTerms('', '');
            });
        }
    }

    const setDisabledDropDown = (blogTypeValue:string) => {
        if (blogTypeValue && blogTypeValue != ""){
            dataOption.disabled = false;
        } else {
            dataOption.options[0].selected = true;
            dataOption.disabled = true;
        }
    }

    // function to show the attribute drop down select when it is not empty and is enabled
    const handleAttributeDropDown = () => {

        let attributeSelect = document.querySelector('.js-attribute-select') as HTMLSelectElement;

        // if drop down select has more than 1 item, show it
        if ((attributeSelect.options.length > 1) && !(attributeSelect.disabled)) {
            attributeSelect.classList.remove('d-none');
        }
    }

    export const init = () => {
        checkURLParams();
        handleDropDownChange();
        handleClearFilter();
        handleAttributeDropDown();
	};
}

document.addEventListener("DOMContentLoaded", () => {
	Worthington.BlogListLibrary.init();
});